import styled from "styled-components";
import { FlexGrowProps } from "styled-system";

import Box from "../Box";

import { CButton, CText } from "@carrefour/design-system-components-react";

type PaginationProps = {
  current: number;
  totalPage: number;
  totalItems: number;
  currentItems: number;
  prevPage: () => void;
  nextPage: () => void;
  lastPage: () => void;
  firstPage: () => void;
} & FlexGrowProps;

const PaginationContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

const Text = styled(CText)`
  font-family: system-ui;
`;

const PaginationCard = ({
  current,
  totalPage,
  totalItems,
  currentItems,
  prevPage,
  nextPage,
  firstPage,
  lastPage,
}: PaginationProps) => {
  const fromItems = (current - 1) * 5 + 1;
  const toItems = fromItems + currentItems - 1;
  return (
    <PaginationContainer>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Text>{fromItems}</Text>
        &nbsp;
        <Text>-</Text>
        &nbsp;
        <Text>{toItems}</Text>
        &nbsp;
        <Text>of</Text>
        &nbsp;
        <Text>{totalItems}</Text>
      </Box>

      <CButton
        data-testid="jump-prev-button"
        appendIcon={"chevron-double-left"}
        variation={"tertiary"}
        tone={"monochrome"}
        onClick={() => firstPage()}
        disabled={current === 1}
      />
      <CButton
        data-testid="prev-button"
        appendIcon={"chevron-left"}
        variation={"tertiary"}
        tone={"monochrome"}
        onClick={() => prevPage()}
        disabled={current === 1}
      />
      <CButton
        data-testid="next-button"
        appendIcon={"chevron-right"}
        variation={"tertiary"}
        tone={"monochrome"}
        onClick={() => nextPage()}
        disabled={current === totalPage}
      />
      <CButton
        data-testid="jump-next-button"
        appendIcon={"chevron-double-right"}
        variation={"tertiary"}
        tone={"monochrome"}
        onClick={() => lastPage()}
        disabled={current === totalPage}
      />
    </PaginationContainer>
  );
};

export default PaginationCard;
